// La navigazione del cruscotto.
//
// DUE TIPI DI VOCE:
//  - AREA di questa pagina: cambia vista, non rotta (`vista` nello stato +
//    ?vista= nell'URL). Le tre viste storiche 'stato' | 'grafo' | 'aiuto' e le
//    13 aree si comportano allo stesso modo.
//  - PAGINA ESTERNA (`ESTERNE`): una rotta vera. Oggi solo l'alimentazione del
//    corpus, che è una pagina a sé perché è un flusso di lavoro lungo.
//
// REGOLA: una voce esterna va resa come <Link>, MAI come window.location.href.
//
// Adattamento rispetto al documento originale: la rotta reale non è più
// `/console/ingestion` ma `/admin/corpus/ingestione` (Riordino della mappa
// delle rotte, Rilascio A passo A.4.5 — precede questo documento e ha
// precedenza su rotte e atterraggi, come dichiarato nell'introduzione).

export interface Esterna { nome: string; href: string }

/* Voci che non sono aree di questa pagina ma pagine separate del cruscotto:
   la navigazione le mostra come le altre e ci porta con un link. */
export const ESTERNE: Record<string, Esterna> = {
  'co-alimenta': { nome: 'Alimentazione del corpus', href: '/admin/corpus/ingestione' },
};

export const GRUPPI_NAV: [string, string[]][] = [
  ['1 · IDENTITÀ E ACCESSI', ['id-idp', 'id-tenant']],
  ['2 · CONOSCENZA', ['grafo', 'co-fonti', 'co-ingest', 'co-alimenta']],
  ['3 · INTELLIGENZA', ['in-gateway', 'in-modelli', 'in-skill']],
  ['4 · PRODUZIONE', ['pr-atti', 'pr-cowork', 'pr-integrazioni']],
  ['TRASVERSALI', ['tr-tracciabilita', 'tr-costi', 'tr-eventi']],
];

/** Le tre viste che non sono aree dichiarate ma schermate proprie. */
export const VISTE_PROPRIE = ['stato', 'grafo', 'aiuto'] as const;
export type Vista = string;
